import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      /* Default */
      {
        path: '',
        redirectTo: 'cashflow',
        pathMatch: 'full'
      },
      /* Paginacion */
      {
        path: 'cashflow',
        loadChildren: './theme/cashflow-page/cashflow-page.module#CashflowPageModule'
      },
      {
        path: 'conciliacion',
        loadChildren: './theme/conciliacion-page/conciliacion-page.module#ConciliacionPageModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
